export const EmptyModules = () => (
  <div className="rounded-lg border border-slate-200 bg-white p-6 text-center text-sm text-ink-secondary">
    No tienes módulos disponibles. Contacta a tu administrador.
  </div>
);
